export default {
  state: {
    snack: "",
  },
  getters: {
    snack: (state) => {
      return state.snack;
    },
  },
  mutations: {
    setSnack(state, value) {
      state.snack = value;
    },
  },
};
